import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import numeral from "numeral";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    labelHTML: {
      type: String,
      default: ""
    },
    align: {
      type: String,
      default: "left"
    },
    contentClass: {
      type: String,
      default: ""
    },
    money: {
      type: Boolean,
      default: false
    },
    formatType: {
      type: String,
      default: ""
    },
    append: {
      type: String,
      default: ""
    },
    valueClass: {
      type: String,
      default: ""
    }
  },
  computed: {
    formattedValue() {
      if (this.formatType === "" && this.$root.$i18n.locale === "fr-CA" && this.value !== null && typeof this.value === "string") {
        var _context, _context2;
        if (_includesInstanceProperty(_context = this.value).call(_context, "years") && _includesInstanceProperty(_context2 = this.value).call(_context2, "months")) {
          const fr1 = this.value.replace("years", "ans");
          const fr2 = fr1.replace("months", "mois");
          return fr2;
        }
        const key = `application-form.${this.value.toLowerCase().replace(" ", "-")}`;
        return key === this.$t(key) ? this.value : this.$t(key);
      }
      numeral.locale("en");
      const formatParser = {
        money: numeral(this.value).format("$0,0.00"),
        percentage: _parseFloat(this.value).toFixed(2) + "%"
      };
      return formatParser[this.formatType] || this.value;
    },
    leftOrder() {
      return this.align === "formattedValueLeft";
    }
  },
  mounted() {
    this.$emit("input");
  }
});